import styled from 'styled-components';

export const ChooseUnitsContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ChooseUnitsSummaryStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const ChooseUnitsSummaryPriceStyled = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 24px;
`;

export const OrderInfoItemTextStyled = styled.p`
	gap: 8px;
	display: flex;
	align-items: center;
	margin: 0;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
`;

export const ChooseUnitsSummaryNameStyled = styled.p`
	margin: 0;
	font-weight: 400;
	font-size: 14px;
`;

export const ChooseUnitsSummaryResultStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const MessageContainerStyled = styled.div`
	margin: 8px 0 24px 0;
	padding: 16px 24px;
	border: 1px solid #91d5ff;
	border-radius: 8px;
	background-color: #e6f7ff;
`;

export const ChooseUnitsSummaryHeadingStyled = styled.h3`
	margin-bottom: 16px;
	font-size: 16px;
`;

export const ChooseUnitsSelectionHeadingStyled = styled.h3`
	margin-bottom: 12px;
	font-weight: 600;
	font-size: 16px;
`;
export const ChooseUnitsSelectedStyled = styled.p`
	margin-bottom: 12px;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const ChooseUnitsPriceContainerStyled = styled.div`
	gap: 5px;
	display: flex;
	align-items: center;
`;
